import './style.scss'
import { WbsItemTypeVO } from '../../../domain/value-object/WbsItemTypeVO'
import ticketListIcon from '../../../assets/icons/global/ticket_list.svg'

export const WbsItemIcon = (props: {
  type?: WbsItemTypeVO
  className?: string
}) => {
  return (
    <>
      {props.type?.iconUrl && (
        <img src={props.type.iconUrl} className={props.className} />
      )}
      {props.type?.isTicket() && props.type?.isDeliverable() && (
        <img src={ticketListIcon} className={props.className} />
      )}
    </>
  )
}
